import { Component, OnDestroy, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { FormGroup } from '@angular/forms';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { Subscription } from 'rxjs';
import { FehmarnDataTabs } from './fehmarn-data-tabs';
import { BasicUsage } from '../chart-tab/BasicUsage';
import { jsPDF } from "jspdf";
import html2canvas from 'html2canvas';
import autoTable from 'jspdf-autotable';


@Component({
  selector: 'app-fehmarn',
  templateUrl: './fehmarn.component.html',
  styleUrls: ['./fehmarn.component.css']
})
export class FehmarnComponent  implements OnDestroy {
  public data: BasicUsage[];
  public dataLine: BasicUsage[];
  public tabIndex: FehmarnDataTabs = FehmarnDataTabs.overview;
  public y: number = 0;
  public x: number = 0;
  


  toSwitchTabSubscription: Subscription;
  tab: number = 0;

  public detailForm = new FormGroup({
  });

  constructor(
    public translate: TranslateService
  ) {

  }

  ngOnInit(): void {
    this.getInfo();
  }

  ngOnDestroy(): void {
    if (this.toSwitchTabSubscription) this.toSwitchTabSubscription.unsubscribe();
  }

  print()
  {
    const doc = new jsPDF('p','mm',"a4");
    let imageFlc = new Image();
    imageFlc.src = 'assets/images_logo/FLC-logo-U60-space-300x300.png';
    const imgProps= doc.getImageProperties(imageFlc);
    const pdfWidth = doc.internal.pageSize.getWidth();
    const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;
    
    this.y = 0;
    this.x = 65;
    console.log(pdfWidth + " " + pdfHeight);
    doc.addImage(imageFlc, 'jpeg', this.x, this.y, pdfWidth / 3, pdfHeight / 3);
    
    this.y = this.y + (pdfHeight / 3);
    this.x = 10;
    const captureElement = document.getElementById("printChart");
    
    if (captureElement)
    {
      // Call the html2canvas function and pass the element as an argument, scale to better dpi to print, default = 1
      html2canvas(captureElement, {scale: 4}).then((canvas) => {
        // Get the image data as a base64-encoded string
        
        let img = new Image();
        img.src = canvas.toDataURL("image/jpeg", 1.0);
        
        //calculate fixed ratio width and height
        console.log(img.src.length);
        if (img.src && img.src.length > 10)
        {
          const imgProps= doc.getImageProperties(img);
          const pdfWidth = doc.internal.pageSize.getWidth();
          const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;
          doc.text("title document", this.x, this.y);
          this.y = this.y + 5;
          doc.addImage(img, 'jpeg', this.x, this.y, pdfWidth, pdfHeight);
          this.y = this.y + 100;
        }
        return doc;
       
      }).then((docResult) => {
        this.printLineChart(docResult);
      });

    }
    else this.printLineChart(doc);
  }
  
  printLineChart(doc: jsPDF)
  {
    const captureElement = document.getElementById("printChartLine");
    
    if (captureElement) {

      // Call the html2canvas function and pass the element as an argument, scale to better dpi to print, default = 1
      html2canvas(captureElement, {scale: 4}).then((canvas) => {
        // Get the image data as a base64-encoded string
        
        let img = new Image();
        img.src = canvas.toDataURL("image/jpeg", 1.0);
        
        console.log(img.src.length);
        if (img.src && img.src.length > 10)
        {
          //calculate fixed ratio width and height
          const imgProps= doc.getImageProperties(img);
          const pdfWidth = doc.internal.pageSize.getWidth();
          const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;
          doc.text("title chart line", this.x, this.y);
          this.y = this.y + 5;
          doc.addImage(img, 'jpeg', this.x, this.y, pdfWidth, pdfHeight);
          this.y = this.y + 100;
        }
        return doc;
       
      }).then((docResult) => {
        autoTable(docResult, {
          startY: this.y,
          head: [['Name', 'Email', 'Country']],
          body: [
            ['David', 'david@example.com', 'Sweden'],
            ['Castille', 'castille@example.com', 'Spain']
          ],
        });
        docResult.save("flc_" + new Date().toLocaleDateString() + "_" + new Date().toLocaleTimeString() + ".pdf");
        });
    }
    else
    {
      doc.save("flc_" + new Date().toLocaleDateString() + "_" + new Date().toLocaleTimeString() + ".pdf");
    }
  }
  

  getInfo()
  {
    this.getItem();
    
  }

  getItem() {

    let data1: BasicUsage = {
      colors: {
        '1': 'green',
        '2': 'blue',
        '3': 'red'
      },
      data: {
        '1': 5,
        '2': 3,
        '3': 6
      },
      month: 1,
      year: 2023
    };

    let data2: BasicUsage = {
      colors: {
        '1': 'green',
        '2': 'blue',
        '3': 'red'
      },
      data: {
        '1': 2,
        '2': 6,
        '3': 0
      },
      month: 2,
      year: 2023
    };

    let dataLine1: BasicUsage = {
      colors: {
        '1': 'green',
        '2': 'yellow',
        '3': 'red'
      },
      data: {
        '1': 5,
        '2': 1,
        '3': 6
      },
      month: 1,
      year: 2023
    };
    let dataLine2: BasicUsage = {
      colors: {
        '1': 'green',
        '2': 'yellow',
        '3': 'red'
      },
      data: {
        '1': 8,
        '2': 4,
        '3': -1
      },
      month: 2,
      year: 2023
    };
    
      this.data = [];
      this.dataLine = [];
      this.data.push(data1);
      this.data.push(data2);
      this.dataLine.push(dataLine1);
      this.dataLine.push(dataLine2);
      
  }

  tabChanged(tabChangeEvent: MatTabChangeEvent) {
    this.tabIndex = tabChangeEvent.index;
  }
}
